import { useAppContext } from "../../layout/layout";
import Wrapper from "./linkedin.styles";
import { Link } from "react-router-dom";
import { AiFillLinkedin } from "react-icons/ai";

const LinkedIn = () => {
  const { isDarkTheme } = useAppContext();
  return (
    <Wrapper>
      <Link
        to="https://www.linkedin.com/in/shafiq-rasa-aba657234/"
        target="_blank"
      >
        <AiFillLinkedin
          className={`icon ${isDarkTheme ? "dlinkedin" : "llinkedin"}`}
        />
      </Link>
    </Wrapper>
  );
};
export default LinkedIn;
